// components/ReglementInterieur.js
import React, { useEffect, useMemo, useState } from "react";
import { getSettings } from "../../services/settingsServices";
import useScrollToTop from "../../hooks/useScollToTop";
import { toAbsolutePhotoUrl } from "../../services/settingsPhotoServices";

const FALLBACK = "/img/article_placeholder.jpg";

const ReglementInterieur = () => {
  useScrollToTop();

  const [settings, setSettings] = useState({
    reglement_interieur: "",
    reglement_interieur_url_header: "",
    reglement_interieur_url_firstimage: "",
    reglement_interieur_url_secondimage: "",
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const settingsData = await getSettings();
        if (Array.isArray(settingsData) && settingsData.length > 0) {
          setSettings((prev) => ({ ...prev, ...settingsData[0] }));
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des données:", error);
      }
    };
    fetchSettings();
  }, []);

  const headerSrc = useMemo(() => {
    const raw = settings.reglement_interieur_url_header?.trim();
    return toAbsolutePhotoUrl(raw) || "";
  }, [settings.reglement_interieur_url_header]);

  const firstSrc = useMemo(() => {
    const raw = settings.reglement_interieur_url_firstimage?.trim();
    return toAbsolutePhotoUrl(raw) || "";
  }, [settings.reglement_interieur_url_firstimage]);

  const secondSrc = useMemo(() => {
    const raw = settings.reglement_interieur_url_secondimage?.trim();
    return toAbsolutePhotoUrl(raw) || "";
  }, [settings.reglement_interieur_url_secondimage]);

  return (
    <div className="container mx-auto pt-[150px] px-4 mb-10 font-montserrat">
      <h2 className="text-2xl uppercase font-bold mb-4 max-w-[1024px] mx-auto">
        Règlement Intérieur
      </h2>

      {/* ✅ Image en en-tête (non coupée) */}
      {headerSrc && (
        <div className="mb-6 max-w-[1024px] mx-auto">
          <div className="rounded-2xl border border-slate-200 overflow-hidden bg-white shadow">
            <img
              src={headerSrc}
              alt="En-tête du Règlement Intérieur"
              className="w-full h-auto max-h-[700px] object-contain bg-slate-50"
              loading="lazy"
              onError={(e) => {
                e.currentTarget.src = FALLBACK;
              }}
            />
          </div>
        </div>
      )}

      {/* Texte */}
      <div className="mb-8 max-w-[1024px] mx-auto">
        <div
          className="prose prose-slate max-w-none"
          dangerouslySetInnerHTML={{ __html: settings.reglement_interieur || "" }}
        />
      </div>

      {/* ✅ Images facultatives (non coupées) */}
      {(firstSrc || secondSrc) && (
        <div className="max-w-[1024px] mx-auto mb-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {firstSrc && (
              <div className="rounded-2xl border border-slate-200 overflow-hidden bg-white shadow">
                <img
                  src={firstSrc}
                  alt="Première image"
                  className="w-full h-auto max-h-[650px] object-contain bg-slate-50"
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.src = FALLBACK;
                  }}
                />
              </div>
            )}

            {secondSrc && (
              <div className="rounded-2xl border border-slate-200 overflow-hidden bg-white shadow">
                <img
                  src={secondSrc}
                  alt="Deuxième image"
                  className="w-full h-auto max-h-[650px] object-contain bg-slate-50"
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.src = FALLBACK;
                  }}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ReglementInterieur;
